<!-- LISTA DE RESULTADOS DA BUSCA -->
<div #resultsContainer class="flex-1 min-h-0 mt-2 w-full overflow-auto bg-gray-100 rounded-md" *ngIf="searchResults.length > 0">
  <div class="p-2">
    <p class="text-sm font-semibold text-gray-700 mb-2">Resultados da busca ({{ searchResults.length }})</p>
    <div class="space-y-1">
      <div 
        *ngFor="let product of searchResults; let i = index"
        [id]="'search-result-item-' + i"
        (click)="selectProductFromList(product)"
        [ngClass]="{
          'bg-orange-500 text-white': selectedProductIndex === i,
          'bg-white hover:bg-orange-50': selectedProductIndex !== i
        }"
        class="p-2 rounded cursor-pointer border border-gray-200 transition-colors">
        <div class="flex flex-col">
          <span class="font-semibold text-sm">{{ product.description }}</span>
          <div class="flex justify-between items-center mt-1">
            <span class="text-xs" [ngClass]="{'text-orange-100': selectedProductIndex === i, 'text-gray-600': selectedProductIndex !== i}">
              Código: {{ product.code }} | Estoque: {{ product.currentStock }}
            </span>
            <span class="font-bold text-sm" [ngClass]="{'text-white': selectedProductIndex === i, 'text-orange-600': selectedProductIndex !== i}">
              {{ product.priceSelling | currency:'BRL' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- IMAGEM LOGO (quando não há resultados de busca) -->
<div class="flex-1 min-h-0 flex justify-center items-center" *ngIf="searchResults.length === 0">
  <img src="imgs/logotipo.png" alt="PDV" class="w-80 h-80">
</div>
